import Head from 'next/head';
import { MainLayout } from '@components';

const Home = () => {
	return (
		<div>
			<Head>
				<title>WaterIQ</title>
				<meta name="description" content="WaterIQ" />
				<link rel="icon" type="image/x-icon" href="/favicon.ico" />
				<link rel="shortcut icon" type="image/x-icon" href="/favicon.ico" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="shortcut icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				<link rel="shortcut icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
			</Head>
			<main></main>
		</div>
	);
};

Home.layout = MainLayout;

export default Home;
